import Tenant from '@/models/tenant/Tenant';
import Paciente from '../pacientes/Pacientes';

export default class Prescricao {
    public id: number;

    public dataPrescricao: string;

    public listaMedicamentos: [];

    public prescricaoCompleta: string;

    public observacao: string;

    public tenantId: number;

    public pacienteId: number;

    public tenant: Tenant;

    public paciente: Paciente;

    constructor() {
      this.id = 0;
      this.dataPrescricao = '0001-01-01T00:00:00';
      this.listaMedicamentos = [];
      this.prescricaoCompleta = '';
      this.observacao = '';
      this.tenantId = 0;
      this.pacienteId = 0;
      this.tenant = new Tenant();
      this.paciente = new Paciente();
    }
}
